var _path, _path2, _g, _rect, _circle, _circle2, _path3, _path4, _g2, _path5, _path6, _g3, _rect2, _rect3, _rect4, _rect5, _rect6, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBot171(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 75H162V94H163.6C165.84 94 166.96 94 167.816 94.436C168.569 94.8195 169.181 95.4314 169.564 96.184C170 97.0397 170 98.1598 170 100.4V119.6C170 121.84 170 122.96 169.564 123.816C169.181 124.569 168.569 125.181 167.816 125.564C166.96 126 165.84 126 163.6 126H140.4C138.16 126 137.04 126 136.184 125.564C135.431 125.181 134.819 124.569 134.436 123.816C134 122.96 134 121.84 134 119.6V100.4C134 98.1598 134 97.0397 134.436 96.184C134.819 95.4314 135.431 94.8195 136.184 94.436C137.04 94 138.16 94 140.4 94H160V75ZM10 100.4C10 98.1598 10 97.0397 10.436 96.184C10.8195 95.4314 11.4314 94.8195 12.184 94.436C13.0397 94 14.1598 94 16.4 94H39.6C41.8402 94 42.9603 94 43.816 94.436C44.5686 94.8195 45.1805 95.4314 45.564 96.184C46 97.0397 46 98.1598 46 100.4V119.6C46 121.84 46 122.96 45.564 123.816C45.1805 124.569 44.5686 125.181 43.816 125.564C42.9603 126 41.8402 126 39.6 126H16.4C14.1598 126 13.0397 126 12.184 125.564C11.4314 125.181 10.8195 124.569 10.436 123.816C10 122.96 10 121.84 10 119.6V100.4Z",
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_42",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 75,
    width: 160,
    height: 51
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160 75H162V94H163.6C165.84 94 166.96 94 167.816 94.436C168.569 94.8195 169.181 95.4314 169.564 96.184C170 97.0397 170 98.1598 170 100.4V119.6C170 121.84 170 122.96 169.564 123.816C169.181 124.569 168.569 125.181 167.816 125.564C166.96 126 165.84 126 163.6 126H140.4C138.16 126 137.04 126 136.184 125.564C135.431 125.181 134.819 124.569 134.436 123.816C134 122.96 134 121.84 134 119.6V100.4C134 98.1598 134 97.0397 134.436 96.184C134.819 95.4314 135.431 94.8195 136.184 94.436C137.04 94 138.16 94 140.4 94H160V75ZM10 100.4C10 98.1598 10 97.0397 10.436 96.184C10.8195 95.4314 11.4314 94.8195 12.184 94.436C13.0397 94 14.1598 94 16.4 94H39.6C41.8402 94 42.9603 94 43.816 94.436C44.5686 94.8195 45.1805 95.4314 45.564 96.184C46 97.0397 46 98.1598 46 100.4V119.6C46 121.84 46 122.96 45.564 123.816C45.1805 124.569 44.5686 125.181 43.816 125.564C42.9603 126 41.8402 126 39.6 126H16.4C14.1598 126 13.0397 126 12.184 125.564C11.4314 125.181 10.8195 124.569 10.436 123.816C10 122.96 10 121.84 10 119.6V100.4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_42)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 66,
    width: 180,
    height: 76,
    fill: "#6A1B9A"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 104,
    width: 180,
    height: 38,
    fill: "black",
    fillOpacity: 0.1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 74,
    width: 2,
    height: 20,
    fill: "white",
    fillOpacity: 0.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 71,
    r: 4,
    fill: "#E1E6E8"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 162,
    cy: 70,
    r: 2,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 22C61.2386 22 59 24.2386 59 27V40H53C51.8954 40 51 40.8954 51 42V52H59H75H83H99H107H123H131V42C131 40.8954 130.105 40 129 40H123V27C123 24.2386 120.761 22 118 22H112C109.239 22 107 24.2386 107 27V40H99V27C99 24.2386 96.7614 22 94 22H88C85.2386 22 83 24.2386 83 27V40H75V27C75 24.2386 72.7614 22 70 22H64Z",
    fill: "#E1E6E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_42",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 22,
    width: 80,
    height: 30
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 22C61.2386 22 59 24.2386 59 27V40H53C51.8954 40 51 40.8954 51 42V52H59H75H83H99H107H123H131V42C131 40.8954 130.105 40 129 40H123V27C123 24.2386 120.761 22 118 22H112C109.239 22 107 24.2386 107 27V40H99V27C99 24.2386 96.7614 22 94 22H88C85.2386 22 83 24.2386 83 27V40H75V27C75 24.2386 72.7614 22 70 22H64Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_42)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    width: 100,
    height: 52,
    fill: "#D500F9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    width: 100,
    height: 40,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 28,
    width: 4,
    height: 8,
    rx: 2,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 28,
    width: 4,
    height: 8,
    rx: 2,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 28,
    width: 4,
    height: 8,
    rx: 2,
    fill: "white",
    fillOpacity: 0.6
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 62C25 52.0589 33.0589 44 43 44H137C146.941 44 155 52.0589 155 62V89.1483C155 93.6831 154.229 98.1848 152.72 102.461L135.239 151.991C132.699 159.187 125.896 164 118.265 164H61.7353C54.1036 164 47.3014 159.187 44.7614 151.991L27.2804 102.461C25.7711 98.1848 25 93.6831 25 89.1483L25 62Z",
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_42",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 130,
    height: 120
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 62C25 52.0589 33.0589 44 43 44H137C146.941 44 155 52.0589 155 62V89.1483C155 93.6831 154.229 98.1848 152.72 102.461L135.239 151.991C132.699 159.187 125.896 164 118.265 164H61.7353C54.1036 164 47.3014 159.187 44.7614 151.991L27.2804 102.461C25.7711 98.1848 25 93.6831 25 89.1483L25 62Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_42)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 42,
    width: 134,
    height: 124,
    fill: "#2979FF"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 134,
    width: 6,
    height: 14,
    rx: 2,
    fill: "black",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 134,
    width: 6,
    height: 14,
    rx: 2,
    fill: "black",
    fillOpacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 134,
    width: 6,
    height: 14,
    rx: 2,
    fill: "black",
    fillOpacity: 0.6
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 134,
    width: 6,
    height: 14,
    rx: 2,
    fill: "black",
    fillOpacity: 0.6
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 48,
    transform: "translate(38 76)",
    fill: "#9F9F9F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 106,
    r: 15,
    fill: "white",
    fillOpacity: 0.1
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 106,
    r: 15,
    fill: "white",
    fillOpacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 106,
    r: 12,
    fill: "white",
    fillOpacity: 0.1
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 106,
    r: 12,
    fill: "white",
    fillOpacity: 0.1
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 106,
    r: 6,
    fill: "white",
    fillOpacity: 0.8
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 106,
    r: 6,
    fill: "white",
    fillOpacity: 0.8
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 106,
    r: 3,
    fill: "white",
    fillOpacity: 0.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 106,
    r: 3,
    fill: "white",
    fillOpacity: 0.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot171);
export default __webpack_public_path__ + "static/media/bot-17-1.67fde5f6e6422ace0650143962161751.svg";
export { ForwardRef as ReactComponent };